import { has, isEmpty, size, get, lowerCase } from 'lodash'
import { http } from '../lib'
import { setMapCenter } from './map'
import {showSuccess, showError} from './error'
import { guessCountryCode } from '../utils/detectCountryCode'
import { store } from '../index'
import { clearUser } from '../actions/user'

export const USER_LOGGED_IN = "USER_LOGGED_IN"
export const ANNOUNCE_LOGGING_IN_USER = "ANNOUNCE_LOGGING_IN_USER"
export const ANNOUNCE_USER_NOT_LOGGED_IN = "ANNOUNCE_USER_NOT_LOGGED_IN"
export const SET_CURRENCY_SYMBOL = "SET_CURRENCY_SYMBOL"

export function announceUserNotLoggedIn() {
    return {
        type: ANNOUNCE_USER_NOT_LOGGED_IN
    }
}

export function announceUserLoggedIn(token, user) {
    return async(dispatch, getState) => {
      dispatch(updatePreferredLocation(user))
      dispatch({
            type: USER_LOGGED_IN,
            token,
            user
        })
    }
}

export function announceLoggingInUser() {
    return {
        type: ANNOUNCE_LOGGING_IN_USER
    }
}

export function signUp(data, history, setOpenSnackBar, setErrorMessage) {
    return async (dispatch, getState) => {
        try {
            dispatch(announceLoggingInUser())
            let [json, success] = await http.post(getState(), 'signup/signup', { data })
            if (success.status === 200 && has(json, 'token')) {
                const userInfoData = json.user
                dispatch(announceUserLoggedIn(json.token, json.user))
                history.push(`/photographer/editdetails`)
            } else {
                dispatch(announceUserNotLoggedIn())
            }
            if (!json.token) {
                setOpenSnackBar(true)
                setErrorMessage("This email address has already  been used. The same email cannot be used to register as a  customer and a photographer")
            }
        } catch (e) {
            setOpenSnackBar(true)
            setErrorMessage(`Failed: ${e}`)
            console.error(e.message)
        }
    }
}

export function isLoggedIn() {
    const token = authToken()
    return ! isEmpty(token) && size(token) > 0
}

// TODO: this function is not called from a react component
//       find a way to avoid store.dispatch
export function authToken() {
  return store.getState().auth.token
}

// TODO: this function is not called from a react component
//       find a way to avoid store.dispatch
export function clearAuthentication() {
  const dispatch = store.dispatch
  dispatch(clearUser())
  dispatch(announceUserNotLoggedIn())
}

export function updatePreferredLocation(user) {
    return async(dispatch, getState) => {
        if ( user.preferred_lat && user.preferred_lng ) {
            setStoredLatLng({lat: user.preferred_lat, lng: user.preferred_lng})
        } else {
            guessCountryCode( ({country_code, position}) => {
                setStoredLatLng(position)
                if ( position.lat && position.lng ) {
                    dispatch(setMapCenter(position))
                }
            })
        }
    }        
}

export const getStoredLatLng = () => {
    return  {lat: parseFloat(window.localStorage.getItem("lat")),
             lng: parseFloat(window.localStorage.getItem("lng"))}
}

export const setStoredLatLng = ({lat, lng}) => {
    if ( lat && lng ) {
        window.localStorage.setItem("lat", lat)
        window.localStorage.setItem("lng", lng)
    }
}

// TODO: all the below functions should be replaced with useSelector from a react component
export function loggedInUser() {
  return store.getState().user.userInfo
}

export function getLoggedInUserId() {
    return get(loggedInUser(), "id")
}

export function loggedInUserLastName() {
    return get(loggedInUser(), "last_name")
}

export function getLoggedInUserEmail() {
    return get(loggedInUser(), "email")
}


export const getLoggedInUserDisplayName = () => {
    return get(loggedInUser(), "first_name")
}


